import { render } from "./ArrowIcon.vue?vue&type=template&id=1d335454&scoped=true&ts=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowIcon.vue?vue&type=script&lang=ts"

import "./ArrowIcon.vue?vue&type=style&index=0&id=1d335454&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d335454"]])

export default __exports__